// extracted by mini-css-extract-plugin
export default {"container":"newsfeed_container__hal0R","header":"newsfeed_header__MHTot"};